export const fonts = {
  titlesNavButtons: 'Space Grotesk, sans-serif',
  regular: 'DM Sans, sans-serif',
};

export const colors = {
  white: '#FFFFFF',
  black: '#000',
  primaryBlue: '#0054FC', // blue500
  darkPrimaryBlue: '#2E4374',
  green300: '#73E3CE',
  green500: '#49FCDA',
  lighterRed: '#FF6B6B',
  greenBlue: '#00FFCF',
  purple200: '#E1A3EF',
  purple600: '#C630E9',
  purple300: '#9D81DD',
  purple350: '#D97AEF',
  blueDark: '#001c4e',
  slateGray: '#8a90a7',
  grayDark: '#11203a',
  greenTurquoise: '#03DAB2',
  green700: '#03DAB2',
  greenDark: '#30D158',
  m3SysDarkOnSurfaceVariant: '#CAC4D0',
  m3SysDarkPrimary: '#D0BCFF',
  blue300: '#5C90F7',
  blue350: '#80A3EA',
  blue600: '#2563eb',
  blue900: '#000E2A',
  blue800: '#011B4E',
  blue700: '#013295',
  m3SysDarkOutline: '#938F99',
  m3SysInverseSurface: '#E6E0E9',
  m3SysInverseOnSurface: '#322F35',
  midnightBlue: '#011B4E',
  darkNavy: '#001335',
  twilightGray: '#4d566a',
  purple700: '#AC16CF',
  gray100: '#EEEEEE',
  gray150: '#F5F5F5',
  gray300: '#CACACA',
  gray550: '#6A6A6A',
  gray700: '#434343',
  gray800: '#4A536C',
  gray900: '#1D1D1D',
  yellow: '#FDED00',
  red500: '#F44336',
  orangeDark: '#FF9F0A',
  redDark: '#FF453A',
  softBlueLinks: '#91B3F6',
  lightGray: '#F2F4F7',
  gray600: '#475467',
  forestGreen: '#2C4334',
  grayBrown: '#3F3831',
  redBrown: '#3A1F23',
  lightBrown: '#E1AD70',
  lightGreen: '#75E5B0',
  lightRed: '#E2A4AB',
  lightOrange: '#FCBB6E',
  lightMintGreen: '#C7F0D9',
  lightBeige: '#F7DEBB',
  lightPink: '#EAD2D5',
  warningDark: '#DC8C2E',
  error800: '#A20009',
  transparent: 'transparent',
  frostOrange: '#ff7300',
  frostOrangeSoft: 'rgba(255, 115, 0, 0.08)',
  deepBlue: '#002793',
  blue650: '#005EFF',
  respiratoryBlue: '#00A0CF',
  respiratoryBlueSoft: 'rgba(0, 160, 207, 0.08)',
  darkPrimaryBlueSoft: 'rgba(46, 67, 116, 0.08)',
  red500Soft: 'rgba(244, 67, 54, 0.08)',
  greenDarkSoft: 'rgba(48, 209, 88, 0.08)',
  agricultureGreen: '#6C8F2A',
  agricultureGreenSoft: 'rgba(108, 143, 42, 0.10)',
  blue600Soft: 'rgba(37, 99, 235, 0.08)',
  gray250: '#D9D9D9',
};

export const componentStyles = {
  textFieldBorderColor: colors.white,
  textFieldInputColor: colors.white,
  modalBackgroundColor: colors.primaryBlue,
  modalBorderRadius: 20,
};
